import React from 'react';
import PropTypes from 'prop-types';

const UniversityRangeIp = ({ userDetails, onIpAddressChange }) => {
  return userDetails.univIpAddresses.map((data, i) => {
    const ipv41 = data.split('-')[0] || '';
    const ipv42 = data.split('-')[1] || '';
    return i > 0 ? (
      <div>
        <div className="col5 add-range-ip">
          <input
            id="ipv4"
            placeholder="IP Address End"
            className="form-control"
            title="IP Value"
            type="text"
            value={ipv42 || ''}
            onChange={e =>
              onIpAddressChange(
                `${ipv41 && ipv41}${e.target.value && `-`}${e.target.value}`,
                i,
                'univIpAddresses',
                true
              )
            }
            contentEditable
          />
        </div>{' '}
        <div className="col5 add-range-ip">
          <input
            className="form-control"
            id="ipv4"
            placeholder="IP Address Start"
            title="IP Value"
            type="text"
            value={ipv41 || ''}
            onChange={e =>
              onIpAddressChange(
                `${e.target.value}${ipv42 && `-`}${ipv42 && ipv42}`,
                i,
                'univIpAddresses',
                true
              )
            }
            contentEditable
          />
        </div>
      </div>
    ) : (
      <div>
        <div className="col5 add-range-ip">
          <input
            id="ip"
            className="form-control"
            placeholder="IP Address End"
            title="IP Value"
            type="text"
            value={ipv42 || ''}
            onChange={e =>
              onIpAddressChange(
                `${ipv41}${e.target.value && `-`}${e.target.value}`,
                i,
                'univIpAddresses',
                true
              )
            }
            contentEditable
          />
        </div>{' '}
        <div className="col5 add-range-ip">
          <input
            className="form-control"
            id="ipv4"
            placeholder="IP Address Start"
            title="IP Value"
            type="text"
            value={ipv41 || ''}
            onChange={e =>
              onIpAddressChange(
                `${e.target.value}${ipv42 && `-`}${ipv42 && ipv42}`,
                i,
                'univIpAddresses',
                true
              )
            }
            contentEditable
          />
        </div>
      </div>
    );
  });
};

UniversityRangeIp.propTypes = {
  dropdownClickFn: PropTypes.func,
  userDetails: PropTypes.Object,
  onIpAddressChange: PropTypes.func,
};
export default UniversityRangeIp;
